<template>
  <v-dialog
    class='sensitivity-filter-popup'
    :value="visiblePopup"
    :max-width="600"
    @click:outside="onNoClickButton()"
    @keydown.esc="onNoClickButton()"
  >
    <v-card class="popup-wrapper">
      <div class="title">{{$t(title)}}</div>
      <div class='sensitivity-wrapper'>
        <v-chip-group
          active-class='primary--text'
          column
          multiple
          :key="visiblePopup"
        >
          <v-chip
            v-for="(sensitivity, index) in sensitivityOptions"
            :key="index"
            @click='addChip(sensitivity)'
            class='sensitivity'
            :class="[sensitivity, { 'is-selected': selectedSensitivity.includes(sensitivity.toLowerCase()) }]"
          >
            {{ sensitivity }}
          </v-chip>
        </v-chip-group>
      </div>
      <div class="buttons">
        <v-btn v-if='showNoButton' small depressed class="no-button btn-secondary" @click="onNoClickButton()">
          {{$t(noCaption)}}
        </v-btn>
        <v-btn small depressed class="yes-button btn-primary" @click="onYesClickButton()" :disabled='saveDisabled'>
          {{$t(yesCaption)}}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>

</template>

<script>
import { CONFIGURATION } from '@/constants/configuration';
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'SelectSensitivityInfrastructureFilterPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  props: {
    title: String,
    yesCaption: String,
    noCaption: String,
    showNoButton: {
      type: Boolean,
      default: true,
      required: false,
    },
    visiblePopup: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selectedSensitivity: [],
    };
  },
  methods: {
    onYesClickButton() {
      this.$emit('clicked', this.selectedSensitivity);
      this.selectedSensitivity = [];
    },
    onNoClickButton() {
      this.$emit('clicked', false);
      this.selectedSensitivity = [];
    },
    addChip(sensitivity) {
      const newValue = sensitivity.toLowerCase();
      if (this.selectedSensitivity.includes(newValue)) {
        this.selectedSensitivity = this.selectedSensitivity.filter(item => item !== newValue);
      } else {
        this.selectedSensitivity.push(newValue);
      }
    },
  },
  computed: {
    sensitivityOptions() {
      return Object.values(CONFIGURATION.InfrastructureSensitivityOptions).map(option => option.charAt(0).toUpperCase() + option.slice(1));
    },
    saveDisabled() {
      return this.selectedSensitivity.length === 0;
    },
  },
};
</script>

<style lang='scss'>
@import '~@/assets/styles/design-system';

.sensitivity-wrapper {
  .v-slide-group__wrapper.v-slide-group__wrapper {
    padding-left: $space-8;
  }
}
</style>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.popup-wrapper {
  max-width: rem(600);
  min-width: rem(600);
  padding: $space-8 $space-10;

  .sensitivity-wrapper {
    min-width: rem(400);
    margin-left: -5%;
    margin-bottom: rem(-10);
    display: flex;
    justify-content: center;

    .sensitivity {
      margin-bottom: $space-1-5;
      background: rgba(43, 175, 105, 0.2);
      border-radius: $radius-sm;
      padding: $space-1 $space-2;
      width: rem(90);
      text-align: center;
      text-transform: capitalize;
      font-size: $font-size-base;
      font-weight: bold;
      height: $btn-height-sm;
      color: var(--severity-low);
      justify-content: center;
      display: flex;

      &.Critical {
        color: var(--severity-critical);
        background-color: var(--severity-critical-bg);
      }

      &.High {
        color: var(--severity-high);
        background-color: var(--severity-high-bg);
      }

      &.Medium {
        color: var(--severity-medium);
        background-color: var(--severity-medium-bg);
      }

      &.Low {
        color: var(--severity-low);
        background-color: var(--severity-low-bg);
      }

      &.Informative {
        color: var(--severity-informative);
        background-color: var(--severity-informative-bg);
      }

      &.is-selected {
        color: var(--brand-primary) !important;
        background-color: var(--brand-primary-bg) !important;
      }
    }

    &__image {
      width: rem(20);
    }
  }

  .title {
    color: var(--text-primary);
    font-size: $font-size-base;
    font-weight: 600;
    letter-spacing: 1.12px;
    line-height: $space-4;
    text-transform: uppercase;
    padding-bottom: $space-6;
  }

  .buttons {
    text-align: right;
    padding-top: $space-7;

    .no-button {
      box-sizing: border-box;
      height: $btn-height-md;
      width: rem(86);
      border: $border-width-thin solid var(--brand-primary);
      color: var(--brand-primary);
      border-radius: $radius-sm;
      background-color: var(--bg-primary);
      box-shadow: $shadow-sm;
    }

    .yes-button {
      height: $btn-height-md;
      width: rem(51);
      border-radius: $radius-sm;
      box-shadow: $shadow-sm;
      font-size: $font-size-sm;
      font-weight: 500;
      letter-spacing: 1.07px;
      line-height: $space-4;
      text-align: center;
      margin-left: $space-2;
    }
  }
}
</style>
